import React, { useState } from 'react';
import axios from 'axios';
import backendUrl from '../BackendUrl';
import '../styles/ResetPassword.css'; // Optional, or inline styles if you'd like

const ResetPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');

  const sendResetCode = async () => {
    try {
      await axios.post(`${backendUrl}/api/accounts/request-password-reset`, { email });
      setMessage('Verification code sent. Check your email.');
      setStep(2);
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error sending code.');
    }
  };

  const verifyCode = async () => {
    try {
      await axios.post(`${backendUrl}/api/accounts/verify-reset-code`, { email, code });
      setMessage('Code verified. Please enter your new password.');
      setStep(3);
    } catch (err) {
      setMessage(err.response?.data?.message || 'Invalid or expired code.');
    }
  };

  const resetPassword = async () => {
    try {
      await axios.post(`${backendUrl}/api/accounts/reset-password`, { email, code, newPassword });
      setMessage('Password reset successfully. You can now log in.');
      setStep(1);
      setEmail('');
      setCode('');
      setNewPassword('');
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error resetting password.');
    }
  };

  return (
    <div className="reset-container">
      <h2>Reset Your Password</h2>
      {step === 1 && (
        <>
          <input
            type="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button onClick={sendResetCode}>Send Verification Code</button>
        </>
      )}

      {step === 2 && (
        <>
          <input
            type="text"
            placeholder="Enter the code sent to your email"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
          <button onClick={verifyCode}>Verify Code</button>
        </>
      )}

      {step === 3 && (
        <>
          <input
            type="password"
            placeholder="Enter new password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
          <button onClick={resetPassword}>Reset Password</button>
        </>
      )}

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default ResetPassword;